import { useAuth } from '~/store/auth'

export default defineNuxtRouteMiddleware(async () => {
  const authCookie = useCookie('token')
  if (!authCookie.value) {
    return
  }
  const userStore = useAuth()
  await userStore.getUser()
})
